import RenderFilterFieldByType from '@buildwise/libs/feed/components/RenderFilterFieldByType';
import { ConfigEntryType } from 'config/config';
import { useCallback, useState } from 'react';
import Description from './Description';
import Attachments from './Attachments';
import { attachFiles } from 'utility/helpers';
import { useFormContext } from 'react-hook-form';
import { ActivityFormValues } from './ActivityForm';
import { AttachmentType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';
import { Box } from '@mui/material';

type RenderFieldProps = {
  field: ConfigEntryType;
  fieldIndex: number;
};

function RenderField({ field, fieldIndex }: RenderFieldProps) {
  const [isLoadingFiles, setIsLoadingFiles] = useState(false);
  const { getValues, setValue } = useFormContext<ActivityFormValues>();

  const onDrop = useCallback((acceptedFiles: File[]) => {
    setIsLoadingFiles(true);
    attachFiles({
      newAttachments: acceptedFiles,
      attachments: getValues('attachments') || [],
      setAttachments: (attachments: AttachmentType[]) => {
        setValue('attachments', attachments, { shouldDirty: true, shouldValidate: true });
        setIsLoadingFiles(false);
      },
    });
  }, []);

  switch (field.entryCode) {
    case 'objectDescription': {
      return (
        <Description
          autoFocus={fieldIndex === 0}
          placeholder={`${field.referenceObject?.placeHolder || 'Add a description'}${field.referenceObject?.isRequired ? '*' : ''}`}
        />
      );
    }

    case 'attachments': {
      return (
        <>
          <Attachments onDrop={onDrop} loadingFiles={isLoadingFiles} />
        </>
      );
    }

    default: {
      return (
        <Box my={1.5}>
          <RenderFilterFieldByType autoFocus={fieldIndex === 0} field={field} />
        </Box>
      );
    }
  }
}

export default RenderField;
